import React from 'react';
import SKJIcon from '../../assets/SKJIcon.png';
import './BlueStrip.css';

const BlueStrip = ({child}) => {
  return (
    <div className="left-strip-container col-md-2">
      <div className="logo">
        <img src={SKJIcon} alt="SkyJumper Logo" className='skj-logo' />
      </div>
{child}
      <div className='skj-text-container'>
        <span className='skj-text'>SKY JUMPER</span>
      </div>
    </div>
  );
};

export default BlueStrip